/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {StepHeaderComponent} from './step-header/step-header.component';
import {StepMaterialListComponent} from './step-material-list/step-material-list.component';
import {StepConfirmSendComponent} from './step-confirm-send/step-confirm-send.component';
import {SpoCreateNewComponent} from './spo-create-new.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CdkStepperModule} from '@angular/cdk/stepper';
import {WizardModule} from '../../shared/wizard/wizard.module';
import {NgbDatepickerModule, NgbDropdownModule, NgbModalModule, NgbTypeaheadModule} from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import {MaterialListModalComponent} from './step-material-list/material-list-modal/material-list-modal.component';
import {MaterialListModule} from '../../shared/material-list/material-list.module';
import {SpoDetailModule} from '../../shared/spo-detail/spo-detail.module';
import {WarningsModule} from '../../shared/warnings/warnings.module';
import {TooltipModule} from '../../shared/tooltip/tooltip.module';
import {ExcelUploadModalComponent} from '../shared/excel-upload/excel-upload-modal/excel-upload-modal.component';
import {LoadingSpinnerModule} from '../../shared/loading/loading-spinner/loading-spinner.module';
import {InputModule} from '../../shared/input/input.module';
import {ConfirmModalModule} from '../../shared/confirm-modal/deprecated-modals/confirm-modal.module';

@NgModule({ declarations: [
        StepHeaderComponent,
        StepMaterialListComponent,
        StepConfirmSendComponent,
        SpoCreateNewComponent,
        MaterialListModalComponent
    ],
    exports: [SpoCreateNewComponent], imports: [CommonModule,
        CdkStepperModule,
        WizardModule,
        ReactiveFormsModule,
        FormsModule,
        NgbDropdownModule,
        NgbTypeaheadModule,
        NgbDatepickerModule,
        NgbModalModule,
        MaterialListModule,
        SpoDetailModule,
        WarningsModule,
        TooltipModule,
        LoadingSpinnerModule,
        InputModule,
        ConfirmModalModule], providers: [provideHttpClient(withXhr(), withInterceptorsFromDi())] })
export class SpoCreateNewModule {
}
